import { AbstractControl } from "@angular/forms";

export class CustomValidators {

    static validatorWhitespace(control: AbstractControl): { [key: string]: boolean } {
        const isWhitespace = (control.value || "").trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespaceInvalid: true };
    }

    static validaTexto(control: AbstractControl): { [key: string]: boolean } {
        const regex = /^([a-zA-ZáéíóúÁÉÍÓÚñÑ]+\s)*[^@!"#$%&/()?¡°.{}[\]][a-zA-ZáéíóúÁÉÍÓÚñÑ]*$/g;

        if (!regex.test(control.value))
            return { textInvalid: true };

        return null;
    }
}


export const cardNumberToBrand = (tarjeta: string) =>{
    var brand: string;
    if(tarjeta.match(new RegExp('^3[47]\\d{0,13}'))){
      brand = 'american express';
    } else if(tarjeta.match(new RegExp('^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}'))){
      brand = 'discover';
    } else if(tarjeta.match(new RegExp('^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}'))){
      brand = 'diners';
    } else if(tarjeta.match(new RegExp('^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}'))){
      brand = 'mastercard';
    } else if(tarjeta.match(new RegExp('^(?:2131|1800)\\d{0,11}'))){
      brand = 'jcb15';
    } else if(tarjeta.match(new RegExp('^(?:35\\d{0,2})\\d{0,12}'))){
      brand = 'jcb';
    } else if(tarjeta.match(new RegExp('^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}'))){
      brand = 'maestro';
    } else if(tarjeta.match(new RegExp('^4\\d{0,15}'))){
      brand = 'visa';
    } else if(tarjeta.match(new RegExp('^62\\d{0,14}'))){
      brand = 'unionpay';
    } else {
      brand = 'Unknown';
    }
    return brand;
  }